import React from 'react';

const Terms = () => {
  return (
    <div className="min-h-screen bg-white pt-32 pb-20">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <h1 className="text-4xl md:text-5xl font-outfit font-800 text-black mb-8">
          Terms & Conditions
        </h1>
        
        <div className="w-24 h-1 bg-crimson mb-12"></div>

        <div className="space-y-8 text-gray-700 font-outfit font-600">
          <section>
            <h2 className="text-2xl font-outfit font-800 text-black mb-4">1. Introduction</h2>
            <p className="leading-relaxed">
              Welcome to AI Day Events. By accessing and participating in AI Day events, you agree to be bound by these Terms and Conditions. 
              AI Day is an initiative by AI Anytime under Sankhyantra Foundation.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-outfit font-800 text-black mb-4">2. Event Participation</h2>
            <p className="leading-relaxed mb-4">
              Participants agree to:
            </p>
            <ul className="list-disc list-inside space-y-2 ml-4">
              <li>Conduct themselves professionally and respectfully</li>
              <li>Follow all event guidelines and instructions from organizers</li>
              <li>Respect intellectual property rights of all presentations and materials</li>
              <li>Not engage in any disruptive or harmful behavior</li>
            </ul>
          </section>

          <section>
            <h2 className="text-2xl font-outfit font-800 text-black mb-4">3. Registration and Tickets</h2>
            <p className="leading-relaxed">
              Event registration may be subject to fees as specified for each event. Registration fees are non-refundable unless the event 
              is cancelled by the organizers. Participants must provide accurate information during registration.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-outfit font-800 text-black mb-4">4. Photography and Media</h2>
            <p className="leading-relaxed">
              By attending AI Day events, participants consent to being photographed, filmed, or recorded. These materials may be used 
              for promotional purposes across AI Anytime's platforms and partner channels.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-outfit font-800 text-black mb-4">5. Liability</h2>
            <p className="leading-relaxed">
              AI Anytime and Sankhyantra Foundation are not liable for any loss, damage, or injury sustained during AI Day events. 
              Participants attend at their own risk.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-outfit font-800 text-black mb-4">6. Intellectual Property</h2>
            <p className="leading-relaxed">
              All content, materials, and presentations at AI Day events remain the property of their respective owners. 
              Unauthorized reproduction or distribution is prohibited.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-outfit font-800 text-black mb-4">7. Changes to Terms</h2>
            <p className="leading-relaxed">
              We reserve the right to modify these terms at any time. Changes will be posted on this page with an updated revision date.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-outfit font-800 text-black mb-4">8. Contact</h2>
            <p className="leading-relaxed">
              For questions about these terms, please contact us through our official channels at AI Anytime.
            </p>
          </section>

          <div className="pt-8 border-t border-gray-800">
            <p className="text-sm text-gray-500">
              Last updated: January 2026
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Terms;
